import { render, staticRenderFns } from "./JsonCSV.vue?vue&type=template&id=5bdbe8d2&scoped=true&"
import script from "./JsonCSV.vue?vue&type=script&lang=js&"
export * from "./JsonCSV.vue?vue&type=script&lang=js&"
import style0 from "./JsonCSV.vue?vue&type=style&index=0&id=5bdbe8d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdbe8d2",
  null
  
)

export default component.exports